'use client';

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { Country, CountryService } from '@/lib/country-service';

interface CountryContextType {
  selectedCountry: Country | null;
  setCountry: (countryCode: string) => void;
  clearCountry: () => void;
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export function CountryProvider({ children }: { children: ReactNode }) {
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  useEffect(() => {
    const country = CountryService.getSelectedCountry();
    setSelectedCountry(country);
  }, []);

  const setCountry = (countryCode: string) => {
    CountryService.setSelectedCountry(countryCode);
    const country = CountryService.getCountryByCode(countryCode);
    setSelectedCountry(country || null);
  };

  const clearCountry = () => {
    CountryService.clearSelectedCountry();
    setSelectedCountry(null);
  };

  return (
    <CountryContext.Provider value={{ selectedCountry, setCountry, clearCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const context = useContext(CountryContext);
  if (context === undefined) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
}
